import React from "react";
import { motion } from "framer-motion";

const SkillBar = ({ name, percent, delay = 0.5 }) => (
  <div className="overflow-x-hidden">
    <p className="text-sm uppercase font-medium font-mono tracking-wide">
      {name}
    </p>
    <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
      <motion.span
        initial={{ x: "-100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay }}
        className="h-full bg-gradient-to-r from-cyan-500 via-indigo-500 to-purple-500 rounded-md relative"
        style={{ width: `${percent}%` }}
      >
        <span className="absolute -top-7 right-0 font-mono text-xs text-cyan-300">
          {percent}%
        </span>
      </motion.span>
    </span>
  </div>
);

const frontendSkills = [
  { name: "React.js", percent: 95 },
  { name: "TypeScript & JavaScript", percent: 93 },
  { name: "Redux / Redux Toolkit / Zustand", percent: 88 },
  { name: "Tailwind CSS / Material-UI / Bootstrap", percent: 90 },
  { name: "HTML5 & CSS3", percent: 95 },
];

const backendSkills = [
  { name: "NestJS", percent: 93 },
  { name: "Node.js & Express.js", percent: 92 },
  { name: "REST API Development & Integration", percent: 92 },
  { name: "PostgreSQL · Prisma ORM · MongoDB · Redis · SQLite", percent: 90 },
  { name: "WebSockets / SSE / Real-time Systems", percent: 90 },
  { name: "JWT · RBAC · OAuth2 · bcrypt", percent: 88 },
  { name: "Multi-tenant · Microservices · System Design", percent: 85 },
  { name: "AWS (EC2, S3) · PM2 · Nginx · Docker · CI/CD", percent: 82 },
  { name: "PayPal · Trustly · Razorpay · Sportradar · Mercoa", percent: 85 },
  { name: "Python / FastAPI", percent: 75 },
  { name: "Git · GitHub · Postman · Jest · Figma · Agile/Scrum", percent: 92 },
];

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            Frontend Skills
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">UI & Client Stack</h2>
        </div>
        <div className="flex flex-col gap-6">
          {frontendSkills.map((skill, i) => (
            <SkillBar
              key={skill.name}
              name={skill.name}
              percent={skill.percent}
              delay={0.35 + i * 0.05}
            />
          ))}
        </div>
      </div>

      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            Backend · Cloud · Architecture
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">
            Full Stack Development
          </h2>
        </div>
        <div className="flex flex-col gap-6">
          {backendSkills.map((skill, i) => (
            <SkillBar
              key={skill.name}
              name={skill.name}
              percent={skill.percent}
              delay={0.35 + i * 0.05}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Skills;
